import { Platform, StatusBar as RNStatusBar, View } from 'react-native';

import { BRAND } from '@sixam/config/brand';

/**
 * Real status bar height on Android. The app root reserves the status bar strip
 * and hands descendants a zeroed safe-area top inset, so screens and modals that
 * need to clear the status bar read this directly instead. Returns 0 on iOS,
 * where the safe-area inset is already correct.
 */
export function androidStatusBarHeight() {
  if (Platform.OS !== 'android') {
    return 0;
  }
  return RNStatusBar.currentHeight ?? 24;
}

/**
 * A dark band the height of the status bar, for modals. Modals render in their
 * own native window on Android, outside the app root that paints the shared
 * strip, so they carry this to keep the notification icons legible. No-op on iOS.
 */
export function ModalStatusBarBand() {
  if (Platform.OS !== 'android') {
    return null;
  }
  return (
    <View
      className="absolute left-0 right-0 top-0"
      pointerEvents="none"
      style={{ backgroundColor: BRAND.color.ink, height: androidStatusBarHeight() }}
    />
  );
}
